import { Component, OnInit } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { AppealService } from '../Appeals/appeal.service';
import { Appeal } from '../Appeals/appeal.model';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';

declare const _: any;

@Component({
    selector: 'appeal-savings-calculations-details-modal',
    templateUrl: './appeal-savings-calculations-details-modal.component.html',
    styleUrls: ['./appeal-savings-calculations-details-modal.component.scss'],
    standalone: false
})
export class AppealSavingsCalculationsDetailsModalComponent implements OnInit, IWeissmanModalComponent<Appeal, void> {
    constructor(
        private bsModalRef: BsModalRef, 
        private appealService: AppealService) { }

    params: Appeal;
    result: void;

    calculationDetails: Core.AppealSavingsCalculationDetails;

    appealId: number;
    totalSavings: number;
    parcelSavingsCalculations: Core.AppealSavingsCalculationDetailsParcel[];
    
    initialized: boolean = false;
    capHeader: string;
    showCap: boolean = false;
    showExemption: boolean = false;
    showRate: boolean = false;
    showBaseRate: boolean = false;
    showTaxableAssessedValue: boolean = false;
    showMarketValue: boolean = false;
    showParcelInfo: boolean = false;
    isSavingsOverridden: boolean = false;
    overriddenSavingsAmount: number = 0;
    rightJustifyCellValue: number = 0;

    async ngOnInit(){
        try{
            this.calculationDetails = await this.appealService.getSavingsCalculationDetailsInfoIconData(this.params);
        }
        finally{
            this.appealId = this.calculationDetails.appealId;
            this.totalSavings = this.calculationDetails.totalSavings;
            this.parcelSavingsCalculations = this.calculationDetails.parcelSavingsCalculations;
            this.capHeader = this.calculationDetails.capName;
            this.showCap = this.calculationDetails.hasAnyCap;
            this.showExemption = this.calculationDetails.hasAnyExemption;
            this.showTaxableAssessedValue = this.calculationDetails.hasAnyTaxableAssessedValue;
            this.showRate = this.calculationDetails.hasAnyRate;
            this.showBaseRate = this.calculationDetails.hasAnyBaseRate;
            this.showMarketValue = this.showCap || this.showExemption;
            this.showParcelInfo =  this.calculationDetails.parcelSavingsCalculations?.length > 1;
            this.isSavingsOverridden = this.params.savingsOverridden;
            this.overriddenSavingsAmount = this.params.savings;
            this.initialized = true;
            this.rightJustifyCellValue = this.getCellCount();
        }
    }

    close(){
        this.bsModalRef.hide();
    }

    getCellCount() : number{
        //5 columns always are present (name of annual assessment type, taxable, taxable market value, taxes)
        return 4 + Number(this.showParcelInfo)
                + Number(this.showCap) 
                + Number(this.showExemption) 
                + Number(this.showMarketValue) 
                + Number(this.showRate) 
                + Number(this.showBaseRate)
                + Number(this.showTaxableAssessedValue);
    }
}
